module.exports = __webpack_public_path__ + "fe85d1043ec57b6e8b6bd50ca807fdd7.svg";